module.exports = __webpack_public_path__ + "img/Tacco_SX.6dcee8f8.png";